import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import '../css/bootstrap-social.css'
import '../css/register.css'
import Cookies from 'universal-cookie';

const cookies = new Cookies();
function Login() {
    document.body.style.backgroundColor = "white"
    const [toggle, setToggle] = useState(false);
    let navigate = useNavigate();
    const [loginMessgage, setLoginMessgage] = useState("");
    const [sendHomePage, setSendHomePage] = useState(false);
    const [err, setErr] = useState("");
    const [form, setForm] = useState({
        username: "",
        password: ""
    });


    function handleChange(e) {
        setErr("");
        const { name, value } = e.target;
        setForm(prev => {
            return { ...prev, [name]: value }
        })
    }


    function handleClick() {
        if (form.username === "" || form.password === "") {
            setErr("All fields are required.");
            return;
        }
        if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(form.username)) {
            form.username = form.username.toUpperCase();
        }
        axios.post("https://newchatapp-mn65.onrender.com/loginform", form)
            .then((res) => {
                var date = new Date();
                date.setDate(date.getDate() + 3);
                if (res.data.token) cookies.set('token', res.data.token, { path: '/', expires: date, sameSite: true });
                setSendHomePage(res.data.success);
                setToggle(!toggle);
                setLoginMessgage(res.data.message);
            })
    }

    function googleAuth() {
        try {
            window.open("https://newchatapp-mn65.onrender.com/googleauth", "_self").then((res) => {
            // console.log(res.data);
        })
        } catch (error) {
            // console.log(error);
        }
    }
    function gitHubAuth() {
        window.open("https://newchatapp-mn65.onrender.com/githubauth", "_self");
    }

    useEffect(() => {
        if (sendHomePage) {
            navigate("../home", { replace: true });
        }
    }, [sendHomePage])

    useEffect(() => {
        if (loginMessgage != "Authentication successful") {
            setErr(loginMessgage);
        }
    }, [toggle]);


    return (
        <div className='register'>
            <h2>ChatApp</h2>
            <div className="registerform">
                <label className='regisLabel' htmlFor="username">Username or Email</label>
                <input name="username" onKeyDown={(e)=>{if(e.keyCode===13){handleClick()}}} onChange={handleChange} value={form.username} autoFocus={true} className='regisInput' title="This field is required" id='username' type="text" />
                <label className='regisLabel' htmlFor="password">Password</label>
                <input name="password" onKeyDown={(e)=>{if(e.keyCode===13){handleClick()}}} onChange={handleChange} value={form.password} className='regisInput' title="This field is required" id='password' type="password" />
                <button onClick={handleClick} className='btnn'>Login</button>
                <Link className='forgotpass' to="/changepass">Forgot password?</Link>
            </div>
            {err && <p className='regiserr'>{err} </p>}
            <div className="btnslogin sociobtns">
                <button onClick={googleAuth} className=' btn btn-social btn-google'><i class="fa-brands fa-google"></i> Google</button>
                <button onClick={gitHubAuth} className=' btn btn-social btn-github'><i class="fa-brands fa-github"></i> Git Hub</button>
            </div>
            Don't have login and password? <Link className='linktolog' style={{ textDecoration: "none", fontWeight: "600", margin: "0.6rem 0" }} to="/register">Sign up</Link>
        </div>
    )
}

export default Login